/* Description product — Tabs */
(function () {
  var ACTIVE_CLASS = 'is-active';

  function initTabs(root) {
    if (!root || root.getAttribute('data-tabs-init') === 'true') return;
    root.setAttribute('data-tabs-init', 'true');

    var wrapper = root.querySelector('.description-product-tabs__nav-wrapper');
    var tabs = [].slice.call(root.querySelectorAll('.description-product-tabs__tab'));
    var panels = [].slice.call(root.querySelectorAll('.description-product-tabs__panel'));

    if (!tabs.length) return;

    function scrollTabIntoView(tab) {
      if (!wrapper || wrapper.scrollWidth <= wrapper.clientWidth) return;
      var target = tab.offsetLeft - (wrapper.clientWidth - tab.offsetWidth) / 2;
      if (target < 0) target = 0;
      if (typeof wrapper.scrollTo === 'function') {
        wrapper.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        wrapper.scrollLeft = target;
      }
    }

    function activate(tab, setFocus) {
      var panelId = tab.getAttribute('aria-controls');

      tabs.forEach(function (item) {
        var selected = item === tab;
        item.classList.toggle(ACTIVE_CLASS, selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.setAttribute('tabindex', selected ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var show = panel.id === panelId;
        panel.classList.toggle(ACTIVE_CLASS, show);
        if (show) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      if (setFocus) tab.focus();
      scrollTabIntoView(tab);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        activate(tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var key = event.key;
        var nextIndex = null;

        if (key === 'ArrowRight' || key === 'Right') nextIndex = (index + 1) % tabs.length;
        if (key === 'ArrowLeft' || key === 'Left') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (key === 'Home') nextIndex = 0;
        if (key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex !== null) {
          event.preventDefault();
          activate(tabs[nextIndex], true);
        }
      });
    });
  }

  function initAll(context) {
    var scope = context || document;
    [].slice.call(scope.querySelectorAll('[data-description-tabs]')).forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Editor de temas de Shopify
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
